import { useQuery } from '@tanstack/react-query'
import type { ActivityFilters, ActivityResponse, ActivityFilterOptionsResponse } from '@/data/types/analytics.types'
import type { ActivityLogDetailResponse } from '@/data/types/costExplorer.types'
import { fetchWithAuth } from '@/data/api/client'

async function getActivityLogs(filters: ActivityFilters): Promise<ActivityResponse> {
    return fetchWithAuth('/api/v1/activity/', {
        method: 'POST',
        body: JSON.stringify(filters),
    })
}

async function getActivityLogDetail(transactionId: string): Promise<ActivityLogDetailResponse> {
    return fetchWithAuth(`/api/v1/activity/${transactionId}`)
}

async function getActivityFilterOptions(): Promise<ActivityFilterOptionsResponse> {
    return fetchWithAuth('/api/v1/activity/filter-options')
}

export function useActivityLogs(filters: ActivityFilters | null, enabled: boolean = true) {
    return useQuery({
        queryKey: ['activityLogs', filters],
        queryFn: () => getActivityLogs(filters!),
        enabled: enabled && filters !== null,
    })
}

export function useActivityLogDetail(transactionId: string | null) {
    return useQuery({
        queryKey: ['activityLog', transactionId],
        queryFn: () => getActivityLogDetail(transactionId!),
        enabled: !!transactionId,
    })
}

export function useActivityFilterOptions() {
    return useQuery({
        queryKey: ['activityFilterOptions'],
        queryFn: getActivityFilterOptions,
        staleTime: 1000 * 60 * 60, // 1 hour - filter options rarely change
    })
}

